module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-260.bff4895.woff2";